export default "/images/sliders.svg?f7f169838f7f1e87e21d2ba4bddbfc3a";